import * as api from '../api/exemption';
import * as exemptionApi from '@modules/assessment/api/exemption';
import { createRequestTypes, START, SUCCESS, ERROR } from './global';
import { makeApiActionCreatorV3 } from '@actions/utils';

// Tax Limitation
export const EXEMPTION_TAX_LIMITATIONS_FETCH = createRequestTypes(
  'APPRAISAL/EXEMPTION_TAX_LIMITATIONS_FETCH',
);

export const fetchExemptionTaxLimitations = makeApiActionCreatorV3(
  api.fetchExemptionTaxLimitations,
  EXEMPTION_TAX_LIMITATIONS_FETCH[START],
  EXEMPTION_TAX_LIMITATIONS_FETCH[SUCCESS],
  EXEMPTION_TAX_LIMITATIONS_FETCH[ERROR],
);

export const EXEMPTION_TAX_LIMITATION_CREATE = createRequestTypes(
  'APPRAISAL/EXEMPTION_TAX_LIMITATION_CREATE',
);

export const createExemptionTaxLimitation = makeApiActionCreatorV3(
  api.createExemptionTaxLimitation,
  EXEMPTION_TAX_LIMITATIONS_FETCH[START],
  EXEMPTION_TAX_LIMITATIONS_FETCH[SUCCESS],
  EXEMPTION_TAX_LIMITATIONS_FETCH[ERROR],
);

export const EXEMPTION_TAX_LIMITATION_UPDATE = createRequestTypes(
  'APPRAISAL/EXEMPTION_TAX_LIMITATION_UPDATE',
);

export const updateExemptionTaxLimitation = makeApiActionCreatorV3(
  api.updateExemptionTaxLimitation,
  EXEMPTION_TAX_LIMITATIONS_FETCH[START],
  EXEMPTION_TAX_LIMITATIONS_FETCH[SUCCESS],
  EXEMPTION_TAX_LIMITATIONS_FETCH[ERROR],
);

export const EXEMPTION_TAX_LIMITATION_DELETE = createRequestTypes(
  'APPRAISAL/EXEMPTION_TAX_LIMITATION_DELETE',
);

export const deleteExemptionTaxLimitation = makeApiActionCreatorV3(
  api.deleteExemptionTaxLimitation,
  EXEMPTION_TAX_LIMITATIONS_FETCH[START],
  EXEMPTION_TAX_LIMITATIONS_FETCH[SUCCESS],
  EXEMPTION_TAX_LIMITATIONS_FETCH[ERROR],
);

// Apply To values
export const APPLYTO_FETCH = createRequestTypes('APPRAISAL/APPLYTO_FETCH');

export const fetchExemptionApplyTo = makeApiActionCreatorV3(
  exemptionApi.fetchExemptionApplyTo,
  APPLYTO_FETCH[START],
  APPLYTO_FETCH[SUCCESS],
  APPLYTO_FETCH[ERROR],
);

// Exemption Amounts / Percent by Taxing Unit
export const EXEMPTION_TAXING_UNITS_FETCH = createRequestTypes(
  'APPRAISAL/EXEMPTION_TAXING_UNITS_FETCH',
);

export const fetchExemptionTaxingUnits = makeApiActionCreatorV3(
  api.fetchExemptionTaxingUnits,
  EXEMPTION_TAXING_UNITS_FETCH[START],
  EXEMPTION_TAXING_UNITS_FETCH[SUCCESS],
  EXEMPTION_TAXING_UNITS_FETCH[ERROR],
);

export const EXEMPTION_TAXING_UNIT_CREATE = createRequestTypes(
  'APPRAISAL/EXEMPTION_TAXING_UNIT_CREATE',
);

export const createExemptionTaxingUnit = makeApiActionCreatorV3(
  api.createExemptionTaxingUnit,
  EXEMPTION_TAXING_UNIT_CREATE[START],
  EXEMPTION_TAXING_UNIT_CREATE[SUCCESS],
  EXEMPTION_TAXING_UNIT_CREATE[ERROR],
);

export const EXEMPTION_TAXING_UNIT_UPDATE = createRequestTypes(
  'APPRAISAL/EXEMPTION_TAXING_UNIT_UPDATE',
);

export const updateExemptionTaxingUnit = makeApiActionCreatorV3(
  api.updateExemptionTaxingUnit,
  EXEMPTION_TAXING_UNIT_UPDATE[START],
  EXEMPTION_TAXING_UNIT_UPDATE[SUCCESS],
  EXEMPTION_TAXING_UNIT_UPDATE[ERROR],
);

export const EXEMPTION_TAXING_UNIT_DELETE = createRequestTypes(
  'APPRAISAL/EXEMPTION_TAXING_UNIT_DELETE',
);

export const deleteExemptionTaxingUnit = makeApiActionCreatorV3(
  api.deleteExemptionTaxingUnit,
  EXEMPTION_TAXING_UNIT_DELETE[START],
  EXEMPTION_TAXING_UNIT_DELETE[SUCCESS],
  EXEMPTION_TAXING_UNIT_DELETE[ERROR],
);

// Exemption Application
export const EXEMPTION_APPLICATION_FETCH = createRequestTypes(
  'APPRAISAL/EXEMPTION_APPLICATION_FETCH',
);

export const fetchExemptionApplication = makeApiActionCreatorV3(
  api.fetchExemptionApplication,
  EXEMPTION_APPLICATION_FETCH[START],
  EXEMPTION_APPLICATION_FETCH[SUCCESS],
  EXEMPTION_APPLICATION_FETCH[ERROR],
);

export const EXEMPTION_APPLICATION_UPDATE = createRequestTypes(
  'APPRAISAL/EXEMPTION_APPLICATION_UPDATE',
);

export const updateExemptionApplication = makeApiActionCreatorV3(
  api.updateExemptionApplication,
  EXEMPTION_APPLICATION_UPDATE[START],
  EXEMPTION_APPLICATION_UPDATE[SUCCESS],
  EXEMPTION_APPLICATION_UPDATE[ERROR],
);

// application lookup modal
export const OPEN_APPLICATION_LOOKUP_MODAL = `APPRAISAL/OPEN_APPLICATION_LOOKUP_MODAL`;
export const CLOSE_APPLICATION_LOOKUP_MODAL = `APPRAISAL/CLOSE_APPLICATION_LOOKUP_MODAL`;
export const LOOKUP_APPLICATION = createRequestTypes(
  `APPRAISAL/LOOKUP_APPLICATION`,
);
export const MODAL_SELECT_APPLICATION_RECORDS = `APPRAISAL/MODAL_SELECT_APPLICATION_RECORDS`;

export const openApplicationLookupModal = mode => ({
  type: OPEN_APPLICATION_LOOKUP_MODAL,
  payload: mode,
});

export const lookupApplication = makeApiActionCreatorV3(
  api.fetchExemptionApplications,
  LOOKUP_APPLICATION[START],
  LOOKUP_APPLICATION[SUCCESS],
  LOOKUP_APPLICATION[ERROR],
);

export const closeApplicationLookupModal = () => ({
  type: CLOSE_APPLICATION_LOOKUP_MODAL,
});

export const applicationLookupModalSelectRecords = payload => ({
  type: MODAL_SELECT_APPLICATION_RECORDS,
  payload,
});

export const EXEMPTION_SEGMENTS_FETCH = createRequestTypes(
  'APPRAISAL/EXEMPTION_SEGMENTS_FETCH',
);

export const fetchExemptionSegments = makeApiActionCreatorV3(
  api.fetchExemptionSegments,
  EXEMPTION_SEGMENTS_FETCH[START],
  EXEMPTION_SEGMENTS_FETCH[SUCCESS],
  EXEMPTION_SEGMENTS_FETCH[ERROR],
);

export const EXEMPTION_SEGMENTS_FETCH_MULTI = createRequestTypes(
  'APPRAISAL/EXEMPTION_SEGMENTS_FETCH_MULTI',
);

export const fetchMultiExemptionSegments = makeApiActionCreatorV3(
  api.fetchMultiExemptionSegments,
  EXEMPTION_SEGMENTS_FETCH_MULTI[START],
  EXEMPTION_SEGMENTS_FETCH_MULTI[SUCCESS],
  EXEMPTION_SEGMENTS_FETCH_MULTI[ERROR],
);

export const EXEMPTION_SEGMENT_ASSOCIATE = createRequestTypes(
  'APPRAISAL/EXEMPTION_SEGMENT_ASSOCIATE',
);

export const associateExemptionSegment = makeApiActionCreatorV3(
  api.associateExemptionSegment,
  EXEMPTION_SEGMENT_ASSOCIATE[START],
  EXEMPTION_SEGMENT_ASSOCIATE[SUCCESS],
  EXEMPTION_SEGMENT_ASSOCIATE[ERROR],
);

export const EXEMPTION_SEGMENT_UPDATE = createRequestTypes(
  'APPRAISAL/EXEMPTION_SEGMENT_UPDATE',
);

export const updateExemptionSegment = makeApiActionCreatorV3(
  api.updateExemptionSegment,
  EXEMPTION_SEGMENT_UPDATE[START],
  EXEMPTION_SEGMENT_UPDATE[SUCCESS],
  EXEMPTION_SEGMENT_UPDATE[ERROR],
);
export const EXEMPTION_SEGMENT_MASS_ASSOCIATE = createRequestTypes(
  'APPRAISAL/EXEMPTION_SEGMENT_MASS_ASSOCIATE',
);

export const massAssociateExemptionSegment = makeApiActionCreatorV3(
  api.massAssociateExemptionSegment,
  EXEMPTION_SEGMENT_MASS_ASSOCIATE[START],
  EXEMPTION_SEGMENT_MASS_ASSOCIATE[SUCCESS],
  EXEMPTION_SEGMENT_MASS_ASSOCIATE[ERROR],
);

export const EXEMPTION_SEGMENT_MASS_DELETE = createRequestTypes(
  'APPRAISAL/EXEMPTION_SEGMENT_MASS_DELETE',
);

export const massDeleteExemptionSegment = makeApiActionCreatorV3(
  api.massDeleteExemptionSegment,
  EXEMPTION_SEGMENT_MASS_DELETE[START],
  EXEMPTION_SEGMENT_MASS_DELETE[SUCCESS],
  EXEMPTION_SEGMENT_MASS_DELETE[ERROR],
);

export const EXEMPTION_BY_SEGMENT_MASS_DELETE = createRequestTypes(
  'APPRAISAL/EXEMPTION_BY_SEGMENT_MASS_DELETE',
);

export const massDeleteExemptionBySegment = makeApiActionCreatorV3(
  api.massDeleteExemptionBySegment,
  EXEMPTION_BY_SEGMENT_MASS_DELETE[START],
  EXEMPTION_BY_SEGMENT_MASS_DELETE[SUCCESS],
  EXEMPTION_BY_SEGMENT_MASS_DELETE[ERROR],
);

export const EXEMPTION_SEGMENTS_CHANGE_PAGE =
  'APPRAISAL/EXEMPTION_SEGMENTS_CHANGE_PAGE';
export const changeExemptionSegmentsPage = page => ({
  type: EXEMPTION_SEGMENTS_CHANGE_PAGE,
  payload: page,
});

export const EXEMPTION_SEGMENTS_CHANGE_PAGE_SIZE =
  'APPRAISAL/EXEMPTION_SEGMENTS_CHANGE_PAGE_SIZE';
export const changeExemptionSegmentsPageSize = pageSize => ({
  type: EXEMPTION_SEGMENTS_CHANGE_PAGE_SIZE,
  payload: pageSize,
});

export const FETCH_TAXING_UNIT_VALUE_TYPES = createRequestTypes(
  'APPRAISAL/FETCH_TAXING_UNIT_VALUE_TYPES',
);

export const fetchTaxingUnitValueTypes = makeApiActionCreatorV3(
  api.fetchTaxingUnitValueTypes,
  FETCH_TAXING_UNIT_VALUE_TYPES[START],
  FETCH_TAXING_UNIT_VALUE_TYPES[SUCCESS],
  FETCH_TAXING_UNIT_VALUE_TYPES[ERROR],
);